import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  align-self: center;
  overflow-y: auto;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding-top: 2rem;
  }
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  & > * {
    width: 45%;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    & > * {
      width: auto;
    }
  }
`;
